import { useState } from 'react';
import { Popup } from 'devextreme-react/popup';
import { TextBox } from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';
import { newToast } from '../../components';
import { useApiSqlEditor } from '../../api/api.sqlEditor';
import { StepUpVerifyResult } from '../../types/types.sqlEditor';

interface Props {
  visible: boolean;
  onClose: () => void;
  onUnlocked: (token: string, expiresAt: string) => void;
}

export const StepUpPopup = ({ visible, onClose, onUnlocked }: Props) => {
  const { stepUpVerify } = useApiSqlEditor();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    if (!code || code.trim().length < 6) {
      newToast('WARNING', 'Ingrese el código de 6 dígitos.', 3);
      return;
    }
    setLoading(true);
    const res = await stepUpVerify(code.trim());
    setLoading(false);
    if (res.internalCode < 200 && res.data) {
      const data = res.data as StepUpVerifyResult;
      newToast('SUCCESS', 'Verificación correcta. Escrituras habilitadas.', 3);
      setCode('');
      onUnlocked(data.UnlockToken, data.ExpiresAt);
      onClose();
    }
    // Si falla, runApi ya mostró el toast con el mensaje del servidor.
  };

  return (
    <Popup
      visible={visible}
      onHiding={onClose}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title="Verificación de seguridad (token)"
      width={380}
      height={230}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div style={{ fontSize: 13, color: '#666' }}>
          Ingrese el código de 6 dígitos de su app autenticadora (Google Authenticator / Authy)
          para habilitar las operaciones de escritura durante unos minutos.
        </div>
        <TextBox
          value={code}
          onValueChanged={(e) => setCode(e.value)}
          placeholder="000000"
          mode="text"
          maxLength={6}
          stylingMode="outlined"
          inputAttr={{ inputMode: 'numeric', autoComplete: 'one-time-code', style: 'letter-spacing:6px;font-size:20px;text-align:center' }}
          onEnterKey={verify}
        />
        <Button text="Verificar" type="default" stylingMode="contained" disabled={loading} onClick={verify} width="100%" />
      </div>
    </Popup>
  );
};

export default StepUpPopup;
